import axios from 'axios';
import Cookies from 'js-cookie';
import moment from 'moment';
import school from '../assets/school';
import { formatGraduationYear } from '../utils/graduationDate';

/**
 * 报名表 + 附件详情预览（与 PageMyjob 打印区一致）
 */
export default {
    data() {
        return {
            loading: false,
            loadError: '',
            myJobData: {},
            fileMethod: {0: '网页端', 1: '煤婆新消息', 2: '微信小程序', 3: '其他'},
            zzmm: {
                1: '中共党员', 2: '中共预备党员', 3: '共青团员', 4: '民革成员', 5: '民盟成员',
                6: '民建成员', 7: '民进成员', 8: '农工党成员', 9: '致公党成员', 10: '九三学社社员',
                11: '台盟成员', 12: '无党派人士', 13: '群众',
            },
            relationType: {0: '父亲', 1: '母亲', 2: '配偶', 3: '子女', 4: '兄弟', 5: '姐妹', 6: '其他'},
            upStatus: {
                idFront: '未上传',
                idBack: '未上传',
                photo: '未上传',
                criminalRecord: '未上传',
            },
            personalAttachmentCount: 0,
            signImgSrc: '',
            segmentAttachMap: {},
            printEducationSegments: [],
            allAttachmentPreviewList: [],
        };
    },
    computed: {
        displayHighestEducation() {
            const d = this.myJobData || {};
            return d.highest_education || d.highestEducation || d.education || '—';
        },
        displayResidentAddress() {
            const d = this.myJobData || {};
            const address = (d.address || '').trim();
            if (address) {
                return address;
            }
            const native = (d.native_place || d.nativePlace || '').trim();
            const hasRegion = (d.resident_province_city || d.residentProvinceCity || d.resident_city || d.residentCity);
            if (native && !hasRegion) {
                return native;
            }
            return '—';
        },
        displayNativePlace() {
            const d = this.myJobData || {};
            const parts = [
                d.resident_province_city || d.residentProvinceCity,
                d.resident_city || d.residentCity,
            ].filter((v) => v != null && String(v).trim() !== '');
            if (parts.length) {
                return parts.join(' ');
            }
            return (d.native_place || d.nativePlace || '').trim() || '—';
        },
        displayPositionsName() {
            const d = this.myJobData || {};
            const entrance = d.entrance_type != null ? d.entrance_type : d.entranceType;
            if (Number(entrance) === 2) {
                return this.formatOperationPositionName(d);
            }
            return (d.positionsName || d.positions_name || '').trim() || '—';
        },
        printPositionNameSizeClass() {
            const name = (this.displayPositionsName || '').trim();
            const len = name.length;
            if (len > 16) {
                return ['print-mt-mid-major--xs', 'print-mt-mid-major--wrap'];
            }
            if (len > 12) {
                return 'print-mt-mid-major--sm';
            }
            if (len > 9) {
                return 'print-mt-mid-major--md';
            }
            return '';
        },
        familyList() {
            return (this.myJobData && this.myJobData.family) || [];
        },
    },
    methods: {
        formatOperationPositionName(d) {
            if (!d) {
                return '—';
            }
            const majorCategory = String(d.major_category || d.majorCategory || '').trim();
            const majorName = String(d.major_name || d.majorName || '').trim();
            const positionsName = (d.positionsName || d.positions_name || '').trim();
            if (majorCategory) {
                return majorCategory;
            }
            if (majorName) {
                return majorName;
            }
            if (positionsName.indexOf('：') !== -1) {
                const parts = positionsName.split('：');
                return parts[parts.length - 1].trim() || positionsName;
            }
            return positionsName || '—';
        },
        pickAttachmentType(item) {
            if (!item) return null;
            return item.attachmentType != null ? item.attachmentType : item.attachment_type;
        },
        pickFileUrl(item) {
            if (!item) return '';
            return item.fileUrl || item.file_url || '';
        },
        pickEducationSegmentOrder(item) {
            if (!item) return null;
            return item.educationSegmentOrder != null
                ? item.educationSegmentOrder
                : item.education_segment_order;
        },
        normalizeEducationRecord(edu) {
            if (!edu) {
                return {};
            }
            return {
                segmentOrder: edu.segmentOrder != null ? edu.segmentOrder : edu.segment_order,
                segmentLabel: edu.segmentLabel || edu.segment_label || '',
                graduatedInstitution: edu.graduatedInstitution || edu.graduated_institution || '',
                major: edu.major || '',
                majorCode: edu.majorCode || edu.major_code || '',
                educationLevel: edu.educationLevel || edu.education_level || '',
                departureDate: edu.departureDate || edu.departure_date,
                isDomestic: edu.isDomestic != null ? edu.isDomestic : edu.is_domestic,
                institutionType: edu.institutionType || edu.institution_type || '',
                qsRanking: edu.qsRanking != null ? edu.qsRanking : edu.qs_ranking,
            };
        },
        getEducationHistoryList() {
            const raw = (this.myJobData && (this.myJobData.educationHistory || this.myJobData.education_history)) || [];
            return raw.map((item) => this.normalizeEducationRecord(item));
        },
        getAttachmentTypeLabel(type, segOrder) {
            const baseMap = {
                1: '身份证正面',
                2: '身份证反面',
                3: '免冠照',
                // 4: '个人简历',
                5: '毕业证',
                6: '学位证',
                7: '学信网学籍验证报告',
                9: '无犯罪记录证明',
                10: '教育部留学服务中心认证',
            };
            const base = baseMap[type] || ('附件类型' + type);
            if ([5, 6, 7, 10].indexOf(type) !== -1 && segOrder != null) {
                const seg = this.printEducationSegments[segOrder];
                const segTitle = seg ? seg.segmentTitle : ('学历段' + (segOrder + 1));
                return segTitle + ' - ' + base;
            }
            return base;
        },
        buildAllAttachmentPreviewList() {
            const files = (this.myJobData && this.myJobData.file) || [];
            const typeOrder = {1: 1, 2: 2, 3: 3, 9: 4, 7: 10, 5: 11, 6: 12, 10: 13, 4: 14};
            const list = files.map((item, index) => {
                const type = this.pickAttachmentType(item);
                const seg = this.pickEducationSegmentOrder(item);
                const url = this.pickFileUrl(item);
                if (!url || type === 8) {
                    return null;
                }
                return {
                    key: 'att-' + index + '-' + type + '-' + (seg != null ? seg : 'g'),
                    type,
                    seg,
                    url,
                    label: this.getAttachmentTypeLabel(type, seg),
                    sort: (typeOrder[type] || 99) * 100 + (seg != null ? seg : 0),
                };
            }).filter(Boolean);
            list.sort((a, b) => a.sort - b.sort);
            this.allAttachmentPreviewList = list;
        },
        resetPersonalAttachmentStatus() {
            this.upStatus = {
                idFront: '未上传',
                idBack: '未上传',
                photo: '未上传',
                criminalRecord: '未上传',
            };
            this.personalAttachmentCount = 0;
        },
        updatePersonalAttachmentCount() {
            let count = 0;
            if (this.upStatus.idFront !== '未上传') count++;
            if (this.upStatus.idBack !== '未上传') count++;
            if (this.upStatus.photo !== '未上传') count++;
            if (this.upStatus.criminalRecord !== '未上传') count++;
            this.personalAttachmentCount = count;
        },
        getSegmentAttachStatus(segIndex, attachmentType) {
            const key = segIndex + '_' + attachmentType;
            return this.segmentAttachMap[key] || '未上传';
        },
        formatAttachUploaded(fileUrl) {
            if (!fileUrl) {
                return '未上传';
            }
            const parts = String(fileUrl).split('.');
            const ext = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
            return ext ? '已上传 (' + ext + ')' : '已上传';
        },
        formatDepartureYearMonth(dep) {
            return formatGraduationYear(dep);
        },
        mapEducationToPrint(edu, segIndex) {
            const normalized = this.normalizeEducationRecord(edu);
            const isDomestic = normalized.isDomestic;
            const isDomesticYes = isDomestic === 1 || isDomestic === '1';
            const isDomesticNo = isDomestic === 0 || isDomestic === '0';
            let institutionLabel = '院校层级';
            let institutionValue = '';
            if (isDomesticYes) {
                institutionValue = normalized.institutionType || '';
            } else if (isDomesticNo) {
                institutionLabel = '院校2025QS排名';
                const qs = normalized.qsRanking;
                institutionValue = qs != null && qs !== '' ? String(qs) : '';
            }
            const dep = normalized.departureDate;
            const departureText = this.formatDepartureYearMonth(dep);
            return {
                segmentTitle: normalized.segmentLabel || ('学历段' + (segIndex + 1)),
                graduatedInstitution: normalized.graduatedInstitution,
                major: normalized.major,
                majorCode: String(normalized.majorCode || '').trim(),
                educationLevel: normalized.educationLevel,
                departureDate: departureText,
                isDomesticText: isDomesticYes ? '是' : (isDomesticNo ? '否' : ''),
                isDomesticYes,
                isDomesticNo,
                institutionLabel,
                institutionValue,
                attachXuexin: this.getSegmentAttachStatus(segIndex, 7),
                attachGrad: this.getSegmentAttachStatus(segIndex, 5),
                attachDegree: this.getSegmentAttachStatus(segIndex, 6),
                attachStudyAbroad: this.getSegmentAttachStatus(segIndex, 10),
            };
        },
        getExpectedEducationLabels(highestEducation) {
            if (highestEducation === '专科') return ['专科信息'];
            if (highestEducation === '本科') return ['本科信息'];
            if (highestEducation === '硕士研究生') return ['本科信息', '研究生信息'];
            if (highestEducation === '博士研究生') return ['本科信息', '研究生信息', '博士信息'];
            return [];
        },
        buildMainTableEducationRecord(label) {
            const d = this.myJobData || {};
            const institution = d.graduated_institution || d.graduatedInstitution || '';
            let institutionValue = d.institution_type || d.institutionType || '';
            if (!institutionValue && institution) {
                if (school['985'].indexOf(institution) !== -1) {
                    institutionValue = '985';
                } else if (school['211'].indexOf(institution) !== -1) {
                    institutionValue = '211';
                } else if (school['双一流'].indexOf(institution) !== -1) {
                    institutionValue = '双一流';
                } else if (d.education === '专科') {
                    institutionValue = '大学专科';
                } else {
                    institutionValue = '普通本科';
                }
            }
            return {
                segmentLabel: label,
                graduatedInstitution: institution,
                major: d.major || '',
                majorCode: '',
                educationLevel: d.education || '',
                departureDate: d.graduation_time || d.graduationTime,
                isDomestic: 1,
                institutionType: institutionValue,
            };
        },
        matchEducationSegmentLabel(recordLabel, expectedLabel) {
            if (!recordLabel || !expectedLabel) return false;
            if (recordLabel === expectedLabel) return true;
            const aliasMap = {
                '专科信息': ['专科', '专科信息'],
                '本科信息': ['本科', '本科信息'],
                '研究生信息': ['研究生', '研究生信息', '硕士研究生'],
                '博士信息': ['博士', '博士信息', '博士研究生'],
            };
            const aliases = aliasMap[expectedLabel] || [expectedLabel];
            return aliases.indexOf(recordLabel) !== -1;
        },
        resolveEducationRecordForSegment(raw, expectedLabels, label, idx) {
            const list = (raw || []).map((item) => this.normalizeEducationRecord(item));
            if (!list.length) {
                if (label === expectedLabels[expectedLabels.length - 1]) {
                    return this.buildMainTableEducationRecord(label);
                }
                return { segmentLabel: label };
            }
            let matched = null;
            list.forEach((edu) => {
                if (this.matchEducationSegmentLabel(edu.segmentLabel, label)) {
                    matched = edu;
                }
            });
            if (matched) return matched;
            const sorted = list.slice().sort((a, b) => {
                const ao = a.segmentOrder != null ? a.segmentOrder : 0;
                const bo = b.segmentOrder != null ? b.segmentOrder : 0;
                return ao - bo;
            });
            const byOrder = sorted.find((edu) => edu.segmentOrder === idx);
            if (byOrder) return byOrder;
            if (sorted.length === expectedLabels.length && sorted[idx]) return sorted[idx];
            if (sorted.length === 1 && expectedLabels.length > 1 && idx === expectedLabels.length - 1) {
                return sorted[0];
            }
            if (idx === expectedLabels.length - 1) {
                return this.buildMainTableEducationRecord(label);
            }
            return { segmentLabel: label };
        },
        buildFallbackEducationSegments() {
            const d = this.myJobData || {};
            const highest = d.highest_education || d.highestEducation || d.education || '';
            const labelMap = {
                '专科': '专科信息',
                '本科': '本科信息',
                '硕士研究生': '研究生信息',
                '博士研究生': '博士信息',
            };
            const institution = d.graduated_institution || d.graduatedInstitution || '';
            let institutionValue = d.institution_type || d.institutionType || '';
            if (!institutionValue && institution) {
                if (school['985'].indexOf(institution) !== -1) institutionValue = '985';
                else if (school['211'].indexOf(institution) !== -1) institutionValue = '211';
                else if (school['双一流'].indexOf(institution) !== -1) institutionValue = '双一流';
                else if (d.education === '专科') institutionValue = '大学专科';
                else institutionValue = '普通本科';
            }
            const dep = d.graduation_time || d.graduationTime;
            return [this.mapEducationToPrint({
                segmentLabel: labelMap[highest] || '学历信息',
                graduatedInstitution: institution,
                major: d.major || '',
                majorCode: '',
                educationLevel: d.education || '',
                departureDate: dep,
                isDomestic: 1,
                institutionType: institutionValue,
            }, 0)];
        },
        buildPrintEducationSegments() {
            const d = this.myJobData || {};
            const highest = d.highest_education || d.highestEducation || d.education || '';
            const expectedLabels = this.getExpectedEducationLabels(highest);
            const raw = this.getEducationHistoryList();
            if (expectedLabels.length > 0) {
                return expectedLabels.map((label, idx) => {
                    const record = this.resolveEducationRecordForSegment(raw, expectedLabels, label, idx);
                    const merged = Object.assign({ segmentLabel: label }, record);
                    return this.mapEducationToPrint(merged, idx);
                });
            }
            if (raw.length > 0) {
                return raw.slice().sort((a, b) => {
                    const ao = a.segmentOrder != null ? a.segmentOrder : 0;
                    const bo = b.segmentOrder != null ? b.segmentOrder : 0;
                    return ao - bo;
                }).map((edu, idx) => this.mapEducationToPrint(edu, idx));
            }
            return this.buildFallbackEducationSegments();
        },
        extractSignImgFromSavedHtml(html) {
            if (!html) return '';
            const match = String(html).match(/print-commitment-signline[\s\S]*?<img[^>]+src="([^"]+)"/i);
            return match ? match[1] : '';
        },
        initSignatureFromData() {
            const d = this.myJobData || {};
            const savedHtml = d.application_html || d.applicationHtml || '';
            const savedSign = this.extractSignImgFromSavedHtml(savedHtml);
            this.signImgSrc = savedSign || '';
        },
        processAttachmentList() {
            const files = (this.myJobData && this.myJobData.file) || [];
            this.segmentAttachMap = {};
            this.resetPersonalAttachmentStatus();
            files.forEach((item) => {
                const type = this.pickAttachmentType(item);
                const seg = this.pickEducationSegmentOrder(item);
                const fileUrl = this.pickFileUrl(item);
                if (type != null && fileUrl) {
                    const segKey = seg != null ? seg : (
                        [5, 6, 7, 10].indexOf(type) !== -1 ? 0 : null
                    );
                    if (segKey != null) {
                        this.segmentAttachMap[segKey + '_' + type] = this.formatAttachUploaded(fileUrl);
                    }
                }
                const typeParts = fileUrl ? fileUrl.split('.') : [];
                const extText = typeParts.length ? typeParts[typeParts.length - 1] : '';
                if (type === 1) {
                    this.upStatus.idFront = extText ? ('已上传 (' + extText + ')') : '已上传';
                }
                if (type === 2) {
                    this.upStatus.idBack = extText ? ('已上传 (' + extText + ')') : '已上传';
                }
                if (type === 3) {
                    this.upStatus.photo = extText ? ('已上传 (' + extText + ')') : '已上传';
                }
                if (type === 9) {
                    this.upStatus.criminalRecord = extText ? ('已上传 (' + extText + ')') : '已上传';
                }
            });
            this.updatePersonalAttachmentCount();
        },
        normalizeMyJobData() {
            if (!this.myJobData) return;
            const d = this.myJobData;
            if (!d.highest_education && !d.highestEducation && d.education) {
                d.highest_education = d.education;
            }
            if (d.graduation_time && !d.graduationTime) {
                d.graduation_time = moment(d.graduation_time).format('YYYY-MM-DD');
            }
            if (!d.photo_url && d.photoUrl) {
                d.photo_url = d.photoUrl;
            }
            if (!d.positionsName && d.positions_name) {
                d.positionsName = d.positions_name;
            }
            const entrance = d.entrance_type != null ? d.entrance_type : d.entranceType;
            if (Number(entrance) === 2) {
                d.positionsName = this.formatOperationPositionName(d);
            }
            d.educationHistory = this.getEducationHistoryList();
            this.printEducationSegments = this.buildPrintEducationSegments();
            this.buildAllAttachmentPreviewList();
        },
        applyPreviewData(data) {
            this.myJobData = data || {};
            if (!this.myJobData.family) {
                this.myJobData.family = [];
            }
            if (!this.myJobData.file) {
                this.myJobData.file = [];
            }
            if (this.myJobData.created_at) {
                this.myJobData.created_at = moment(this.myJobData.created_at).format('YYYY-MM-DD');
            }
            this.myJobData.familyNum = this.myJobData.family.length + 1;
            this.processAttachmentList();
            this.initSignatureFromData();
            this.normalizeMyJobData();
        },
        loadApplicationPreview(applicationId) {
            if (!applicationId) {
                this.loadError = '报名信息不存在';
                return Promise.resolve();
            }
            if (!Cookies.get('reqToKen')) {
                this.loadError = '请先登录';
                return Promise.resolve();
            }
            this.loading = true;
            this.loadError = '';
            return axios.get('/zhaopinapi/job-applications/' + applicationId + '/preview', {
                headers: { Authorization: Cookies.get('reqToKen') },
            }).then((res) => {
                const _d = res.data;
                if (_d.success && _d.data) {
                    this.applyPreviewData(_d.data);
                } else {
                    this.loadError = _d.message || '加载报名信息失败';
                    this.myJobData = {};
                }
            }).catch((error) => {
                console.log(error);
                this.loadError = '加载报名信息失败';
                this.myJobData = {};
            }).finally(() => {
                this.loading = false;
            });
        },
    },
};
